import { Link } from "react-router-dom";
import BrandMark from "@/components/brand/BrandMark";
import { navLinks } from "./navLinks";

const columnLabel = "font-mono text-xs uppercase tracking-[0.08em] text-muted-foreground";
const columnLink = "text-[15px] text-foreground hover:text-accent-text";

const legalLinks = [
  { label: "Privacy Policy", to: "/privacy-policy" },
  { label: "Terms of Service", to: "/terms-of-service" },
  { label: "Cookie Policy", to: "/cookie-policy" },
];

const Footer = () => (
  <footer className="border-t border-border bg-background">
    <div className="mx-auto flex max-w-[1200px] flex-wrap gap-x-16 gap-y-10 px-[clamp(16px,5vw,48px)] pb-10 pt-14">
      <div className="flex flex-[1_1_260px] flex-col gap-3.5">
        <BrandMark />
        <span className="text-[15px] text-muted-foreground">Sksenq LLC · Yerevan, Armenia</span>
        <a href="mailto:hello@sksenq.com" className="text-[15px] font-medium text-accent-text hover:text-foreground">
          hello@sksenq.com
        </a>
      </div>
      <div className="flex flex-wrap gap-x-16 gap-y-9">
        <div className="flex flex-col gap-3">
          <span className={columnLabel}>Company</span>
          {[...navLinks, { label: "Contact", href: "#contact" }].map((link) => (
            <a key={link.href} href={link.href} className={columnLink}>
              {link.label}
            </a>
          ))}
        </div>
        <div className="flex flex-col gap-3">
          <span className={columnLabel}>Products</span>
          <a
            href="https://taskduck.com"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 text-[15px] text-foreground hover:text-accent-text"
          >
            TaskDuck
            <span className="rounded-full border border-border px-[7px] py-0.5 font-mono text-[10px] uppercase tracking-[0.06em] text-muted-foreground">
              Soon
            </span>
          </a>
        </div>
        <div className="flex flex-col gap-3">
          <span className={columnLabel}>Legal</span>
          {legalLinks.map((link) => (
            <Link key={link.to} to={link.to} className={columnLink}>
              {link.label}
            </Link>
          ))}
        </div>
      </div>
    </div>
    <div className="mx-auto max-w-[1200px] border-t border-border px-[clamp(16px,5vw,48px)] pb-8 pt-5 font-mono text-xs text-muted-foreground">
      © {new Date().getFullYear()} Sksenq LLC
    </div>
  </footer>
);

export default Footer;
